var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frow callout"},[_vm._v("A network of guides to help you"),_c('br'),_vm._v("navigate life.")])}]

export { render, staticRenderFns }